export default __webpack_public_path__ + "fb5809687714d5588e6eb33d663abed6.svg";